import styled, { css } from "styled-components";
import PhoneInput from "ui/common/components/input/PhoneInput/PhoneInput";

export const PhoneInputRoot = styled(PhoneInput)(
    () => css`
        .TextInput {
            height: 100%;
            padding: 1rem 1.25rem;
        }

        .TextInput input {
            font-weight: bold;
        }
    `,
);
